import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { GridConfig, Shelf } from '@app-model/shelf';
import { OpenService } from '@app-services/open.service';
import { SessionService } from '@app/store/session/session.service';

@Component({
  selector: 'app-shelf-grid-item',
  templateUrl: './shelf-grid-item.component.html',
  styleUrls: ['./shelf-grid-item.component.scss']
})
export class ShelfGridItemComponent implements OnInit {

  @Input() shelf: Shelf;
  constructor(
    private elRef: ElementRef,
    private openService: OpenService

    
  ) { }

  gridLineHeight: string;
  gridInlineContainerHeight: string;
  currentInlinePage = 0;
  lastInlinePage = 0;

  ngOnInit(): void {
    this.openService.getLayoutVars().subscribe(layoutVars => {
      if (layoutVars) {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
      }
    }
    );

    this.fillGridLineHeight(this.shelf?.gridConfig);
  }

  ngAfterViewInit() {
    const itemsPerRow = this.shelf.gridConfig?.itemsPerRow;
    if (itemsPerRow) {
      this.elRef.nativeElement.style.setProperty('--items-per-row', itemsPerRow.toString());
    }

    this.lastInlinePage = Math.ceil(this.shelf.images.length / itemsPerRow) - 1;
  }

  nextInlinePage() {
    const itemsPerRow = this.shelf.gridConfig.itemsPerRow;
    const totalPages = Math.ceil(this.shelf.images.length / itemsPerRow);
    this.currentInlinePage = (this.currentInlinePage + 1) % totalPages;
  }

  prevInlinePage() {
    const itemsPerRow = this.shelf.gridConfig.itemsPerRow;
    const totalPages = Math.ceil(this.shelf.images.length / itemsPerRow);
    this.currentInlinePage = (this.currentInlinePage - 1 + totalPages) % totalPages;
  }

  private fillGridLineHeight(gridConfig: GridConfig) {
    if (!gridConfig) {
      return;
    }

    const itemsPerRow = gridConfig.itemsPerRow;
    const lineHeight = gridConfig.lineHeight;
    const isBlock = gridConfig.format === 'BLOCK';

    if(isBlock && lineHeight && this.shelf.images?.length > itemsPerRow) {
      const rows = Math.ceil(this.shelf.images.length / itemsPerRow);
      this.gridLineHeight = `${rows * lineHeight}px`;
    }else if(lineHeight){
      this.gridLineHeight = `${lineHeight}px`;
      this.gridInlineContainerHeight = `${lineHeight + 3}px`;
    }
  }

  redirect(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

}